// extracted by mini-css-extract-plugin
export var active = "Carousel-module--active--a4575";
export var arrow = "Carousel-module--arrow--61497";
export var inner = "Carousel-module--inner--b21ec";
export var item = "Carousel-module--item--e5aad";
export var left = "Carousel-module--left--4e5ee";
export var outer = "Carousel-module--outer--39132";
export var photo = "Carousel-module--photo--0d258";
export var right = "Carousel-module--right--66c5e";